<style scoped lang="scss">
.breads{
  overflow:auto;line-height: 48px;margin-bottom:  20px;
}
.desc{
  font-size: 16px;text-indent: 0;margin-bottom:20px;
}
.compose-type{
    background: #f6fafd;
    padding-bottom: 80px;
    margin-top: 100px;
}
.process-img /deep/ img{
  width: 100%;
  margin:0 auto;
  margin-top:50px;
}
@media screen and (max-width: 640px) {
  .compose-type {
    margin-top: 50px;
    padding-bottom: 30px;
  }
  .process-img /deep/ img{
    margin-top:20px;
  }
}

</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <!--  基因合成-大片段及基因组合成 -->
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <!-- banner -->
    <gene-top-banner :smallTitle="smallTitle" :bigTitle="bigTitle"></gene-top-banner>
    <section v-if="!$route.meta.invisibles">
      <!-- 导航 -->
      <div class="breads container">
        <bread></bread>
      </div>
      <!-- 概述 -->
      <div class="container">
        <p class="desc mb20">利用 overlap PCR 技术获取 DNA 长片段，并进一步利用分子克隆技术在 DNA 片段基础之上进行酶学拼装，是一种有效的长片段DNA 合成方法。</p>
        <p class="desc">
          在长链基因合成领域，擎科生物开发的超长片段快速基因合成技术，成功突破酵母组装多片段、大片段的核心技术，可工业化生产50 kb大片段DNA，合成长度可达
          <span class="nowrap">200 kb。</span>
        </p>
        <mobile-img class="process-img" url="images/gene_second/large_fragments_page/process" imgAlt="大片段及基因组合成-合成长度可达200kb"></mobile-img>
      </div>
      <!-- 产品优势 -->
      <div class="compose-type">
        <div class="container">
          <en-title title="产品优势" enTitle="Advantages"></en-title>
          <gene-advantages :menuTitle="bigTitle" :advantagesList="advantagesList" ></gene-advantages>
        </div>
      </div>
      <!-- 服务内容 -->
      <div class="container">
        <en-title title="服务内容" enTitle="Service Details"></en-title>
        <gene-detail-table :tableColumn="tableColumn" :tableData="tableData" :tableSpanMethod="tableSpanMethod"></gene-detail-table>
      </div>
      <!-- 交付结果 -->
      <div class="container">
        <en-title title="交付结果" enTitle="Deliverables"></en-title>
        <gene-deliverables :products="products" :reports="reports"></gene-deliverables>
      </div>
      <!-- 应用领域 -->
      <div class="container">
        <en-title title="应用领域" enTitle="Application"></en-title>
        <p class="desc">目前，对人工合成的超长片段DNA分子的应用已经扩展到生物科技的很多方面，凭借人工合成技术的发展，科学家在育种改造、医疗健康、污染防治以及数据存储等众多领域取得了更进一步的成果；也为人类改善粮食问题，研发新型药物，优化疾病治疗手段，解决环境问题，探寻更理想数据存储方式等课题，提供了更多解决方案。</p>
      </div>
      <!-- 订购与咨询 -->
      <div class="container">
          <new-consult type="gene" :typeList="['orderOnline','telePhone','download','email']"></new-consult>
      </div>
    </section>
  </div>
</template>
<script>
import bread from "@/components/bread"
import GeneTopBanner from "./gene-components/geneTopBanner"
import EnTitle from '@/components/EnTitle'
import GeneAdvantages from './gene-components/geneAdvantages'
import GeneDetailTable from './gene-components/geneDetailTable'
import GeneDeliverables from './gene-components/geneDeliverables'
import MobileImg from '@/components/MobileImg'
export default {
  components:{
    bread, 
    GeneTopBanner,
    EnTitle,
    GeneAdvantages,
    GeneDetailTable,
    GeneDeliverables,
    MobileImg,
  },
  data () {
    return {
      smallTitle:'全基因组合成',
      bigTitle:'大片段及基因组合成',
      advantagesList:[
        {
          img:'gene_second/large_fragments_page/icon_1',
          title:'NGS验证序列100%准确',
        },
        {
          img:'gene_second/large_fragments_page/icon_2',
          title:'酵母体内组装技术',
        },
        {
          img:'gene_second/large_fragments_page/icon_3',
          title:'长达200 kb',
        },
        {
          img:'gene_second/large_fragments_page/icon_4',
          title:'高性价比',
        }
        
      ],
      tableColumn:[
        {
          label:'基因长度',
          prop:'geneLength',
        },
        {
          label:'生产周期（工作日）',
          prop:'productionCycle',
        },
        {
          label:'载体',
          prop:'carrier',
        },
      ],
      tableData:[
        {
          geneLength:'> 10 kb',
          productionCycle:'咨询',
          carrier:'pCC1413',
        }
      ],
      products:'冻干质粒 DNA 一管 ( 高拷贝约4 μg/ 管，低拷贝1-4 μg/ 管 )\n含有重组质粒的穿刺菌一管',
      reports:'测序结果\nCOA 文件'
    }
  },
  methods: {
    tableSpanMethod(){}
  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/large_fragments_page.vue